
import React , { useContext  , useState  , useRef } from 'react'; 

import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import Layout from 'js/components/page-components/Layout.js'; 


const GeneralLoadingPage = (props) => {
    return (
        <Layout>
            <div className="PG_GeneralLoadingPage" style={{ flexGrow: '1' , position: 'relative' , maxWidth: '1400px' , paddingLeft : '20px' , paddingRight : '20px' , marginLeft: 'auto' , marginRight : 'auto'}}  >
                <br />
                <div className="header">
                    <Skeleton variant="rectangular" width={310} height={30} style={{ paddingLeft : '20px' ,  textAlign: 'left' , verticalAlign: 'middle' , lineHeight: '30px'}}></Skeleton>
                </div> <br />
                <Skeleton variant="rectangular" width={'50%'} height={118} />
                <br />
                <Skeleton variant="rectangular" width={'50%'}  height={40} />
                <br /><Skeleton variant="rectangular" width={'70%'}  height={118} />
                <Skeleton variant="rectangular" width={'70%'}  height={218} />
                <br />
                 <br /><Skeleton variant="rectangular" width={210} height={80} />

                 </div>
        </Layout>
    );
};
 


export default GeneralLoadingPage; 